import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { GenaralRuleField } from "@/modules/GeneralRules/models/GenaralRuleField.model";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { Http } from "@status/codes";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { RolesService } from "@/modules/Roles/services/RolesService";
import {
  BETWEEN_OPERATOR,
  CHANGE_OPERATOR,
  GENERAL_RULES_CONSTANTS,
  INCLUDE_OPERATOR,
  INPUT_TYPE,
  SEND_TIME_UNIT_EXE_NOTIFICATION,
  TIME_RELATED_FILTERS_NOTIFICATION_EXE,
  TIME_UNITS
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { STATE } from "@/shared/constants/GeneralConstants";
import { PreventKey } from "@/shared/mixins/mixins";
import { AxiosError } from "axios";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { USER_TEMPLATES_ACCESS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { ROLES_ACCESS } from "@/modules/Roles/constants/RoleConstants";
import { RangeSlider } from "@/modules/GeneralRules/models/RangeSlider.model";
import { ListService } from "@/modules/List/services/ListService";
import { LIST_ACCESS } from "@/modules/List/constants/ListConstants";

Vue.use(Vuetify);

@Component({
  name: "DisplayValue"
})
export default class DisplayValue extends PreventKey {
  @Prop() private fieldProp!: GenaralRuleField;
  @Prop({ default: "" }) private valueProp?: any;
  @Prop() operator!: string;
  @Prop() index!: number;
  @Prop() indexChanged?: number;
  @Prop() timeUnitProp?: string;

  @Inject() serviceTemplateService!: ServiceTemplateService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() rolesService!: RolesService;
  @Inject() listService!: ListService;

  basicClass = STYLE_CLASSES.BASIC_PRIMARY;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  vSelectClass = STYLE_CLASSES.FLEX_NOWRAP;
  CANCEL = GENERAL_RULES_CONSTANTS.CANCEL_DATE;
  OK = GENERAL_RULES_CONSTANTS.OK_DATE;
  NO_DATA_LIST = GENERAL_RULES_CONSTANTS.NO_DATA_LIST;
  SELECTED = GENERAL_RULES_CONSTANTS.SELECTED;
  TIME_RELATED_FILETRS = TIME_RELATED_FILTERS_NOTIFICATION_EXE;
  timeUnitList = TIME_UNITS;
  timeUnit = "";
  menu = false;
  value: any = "";
  date: string | string[] = "";
  list: List[] = [];
  isRange = false;
  isMultiple = false;
  consultedList: { key: string; list: List[] }[] = [];
  requiredField = [this.handleRules];
  nowDate = new Date().toISOString().slice(0, 10);
  integerDecimalField = FORM_VALIDATORS.INTEGER_AND_DECIMAL_NUMBER_FIELD;
  integerField = FORM_VALIDATORS.NUMBER_FIELD;
  rangeValue = [this.rangeRule];
  rangeSlider: RangeSlider = {
    minimum: 0,
    maximum: 0,
    step: 1
  };

  async mounted() {
    const timeUnitInit =
      this.timeUnitList.find(e => e.value == this.timeUnitProp) ??
      this.timeUnitList[0];
    await this.setTimeUnit(timeUnitInit);
    this.handleFlied();
    this.enableMultipleSelection();
    if (this.valueProp) this.value = this.valueProp;
  }

  @Watch("valueProp")
  setValue() {
    this.value = this.valueProp;
  }

  @Watch("value")
  handleValue() {
    if (this.value) {
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SET_VALUE, this.value);
    }
  }

  @Watch("fieldProp")
  async handleFlied() {
    if (
      this.fieldProp.display == INPUT_TYPE.DATE_PICKER &&
      this.operator != INCLUDE_OPERATOR.key &&
      this.operator != BETWEEN_OPERATOR.key
    ) {
      this.date = this.value;
    }
    if (this.fieldProp.display == INPUT_TYPE.SELECT) {
      this.list = [];
      if (this.fieldProp.value) this.list = this.fieldProp.value;
      else {
        const listConsulted = await this.handleList(this.fieldProp.key);
        if (listConsulted.length > 0) this.list = listConsulted;
      }
    }
    if (
      this.fieldProp.display == INPUT_TYPE.SLIDER &&
      this.fieldProp.value &&
      this.fieldProp.value.length > 1
    ) {
      this.fieldProp.value.forEach(({ key, name }) => {
        if (name in this.rangeSlider) {
          this.rangeSlider[name as keyof RangeSlider] = parseInt(key);
        }
      });
    }
  }

  @Watch("operator")
  enableMultipleSelection() {
    if (this.index == this.indexChanged) this.value = "";
    if (
      this.operator == INCLUDE_OPERATOR.key ||
      this.operator == BETWEEN_OPERATOR.key
    ) {
      this.isRange = true;
      this.isMultiple = true;
      this.date = ["", ""];
    } else if (this.operator == CHANGE_OPERATOR.key)
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.SET_VALUE, this.value);
    else {
      this.isRange = false;
      this.isMultiple = false;
      this.date = "";
    }
  }

  setDate(date: string[] | string) {
    if (Array.isArray(date)) {
      if (date.length === 1) {
        Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.MUST_BE_RANGE);
        return;
      }

      const date1 = new Date(date[0]).getTime();
      const date2 = new Date(date[1]).getTime();

      if (date1 > date2) {
        date = [date[1], date[0]];
      }
    }

    this.menu = false;
    this.value = date;
    this.date = date;
  }

  async handleList(key: string) {
    let list: List[] = [];
    const existList = this.consultedList.find(item => item.key == key);
    if (!existList || existList.list.length == 0) {
      if (list.length == 0) {
        switch (key) {
          case "service":
            list = await this.getServiceTemplates();

            break;
          case "userTemplate":
            list = await this.getUserTemplates();

            break;
          case "roles":
            list = await this.getRoleList();
            break;
          case "state":
            list = await this.getMedicalAppointmentStateList();
        }
        this.addConsultedList(key, list);
      }
    } else {
      list = existList.list;
    }
    return list;
  }

  async getServiceTemplates() {
    try {
      const response = await this.serviceTemplateService.getAllActiveServiceTemplate(
        STATE.ACTIVE
      );
      if (response.code === Http.Found && response.data) {
        const serviceTemplates = response.data;
        const serviceTemplatesList: List[] = [];
        serviceTemplates.forEach(({ id, internalName }) => {
          serviceTemplatesList.push({
            key: id as string,
            name: internalName
          });
        });
        return serviceTemplatesList;
      } else {
        Snackbar.popInfo(response.message);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  async getUserTemplates() {
    try {
      const response = await this.userTemplateService.getAllActiveUserTemplates();
      if (response.code === Http.Found && response.data) {
        const formTemplatesUser = response.data;
        const formTemplatesUserList: List[] = [];
        formTemplatesUser.forEach(({ _key, name }) => {
          formTemplatesUserList.push({ key: _key, name });
        });
        return formTemplatesUserList;
      } else {
        Snackbar.popInfo(response.message);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  async getRoleList() {
    try {
      const response = await this.rolesService.getAllActiveRoles();

      if (response.code === Http.Found && response.data) {
        const rolesUser = response.data;
        const rolesUserList: List[] = [];
        rolesUser.forEach(({ id, name }) => {
          rolesUserList.push({ key: id, name });
        });
        return rolesUserList;
      } else {
        Snackbar.popInfo(response.message);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + ROLES_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  addConsultedList(key: string, list: List[]) {
    if (list.length > 0) {
      this.consultedList.push({ key, list });
    }
  }

  handleRules(v: string) {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.HANDLE_RULES, v);
    if (v && (Array.isArray(v) ? (v.length > 0 ? true : false) : true)) {
      return true;
    } else {
      return FORM_MESSAGES.REQUIRED_FIELD;
    }
  }

  rangeRule(v: string) {
    const { minimum: min, maximum: max, step } = this.rangeSlider;
    const number = parseInt(v);

    if (!(number >= min && number <= max)) {
      return FORM_MESSAGES.RANGE_CONDITION.OUT_RANGE;
    }

    if ((number - min) % step !== 0) {
      const lower = min + Math.floor((number - min) / step) * step;
      const upper = lower + step;

      let validNumber = 0;

      if (lower >= min && upper <= max) {
        validNumber =
          Math.abs(number - lower) < Math.abs(number - upper) ? lower : upper;
      } else {
        validNumber = upper > max ? lower : upper;
      }

      return FORM_MESSAGES.RANGE_CONDITION.CONDITION_DENIED.replace(
        "{{valor}}",
        validNumber.toString()
      );
    }

    return true;
  }
  async getMedicalAppointmentStateList() {
    try {
      const response = await this.listService.getAppointmentStatus();
      if (response.code === Http.Found && response.data) {
        const appoitmentStateList = response.data;
        const StateList: List[] = [];
        appoitmentStateList.options.forEach(({ value, title }) => {
          StateList.push({
            key: value as string,
            name: title
          });
        });
        return StateList;
      } else {
        Snackbar.popInfo(response.message);
        return [];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      return [];
    }
  }
  setTimeUnit(timeUnit: { label: string; value: string }) {
    this.timeUnit = timeUnit.value;
    this.$emit(SEND_TIME_UNIT_EXE_NOTIFICATION, this.timeUnit);
  }
}
